// extracted by mini-css-extract-plugin
export default {"third":"Investments_third__sj9n2","text_container3":"Investments_text_container3__Y4noN","image3":"Investments_image3__mzzCU","separator":"Investments_separator__zbGfW"};